<template>
  <div class="d-none d-lg-inline-block ml-11">
    <button type="button" class="btn header-item" v-b-modal.agents-online-modal>
      {{ agentsOnline ? agentsOnline.length : '-' }} {{
        (agentsOnline && agentsOnline.length === 1) ? 'Agent' :
            'Agents'
      }} Online
    </button>
    <b-modal hide-footer id="agents-online-modal" title="Agents Online">
      <div v-if="isLoading" class="text-center">
        <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
      </div>

      <div v-if="!isLoading && agentsOnline.length === 0" class="alert alert-danger">
        No agents online
      </div>

      <div v-if="!isLoading && agentsOnline.length" class="table-responsive mb-0">
        <table class="table mb-0 table-centered">
          <thead class="thead-light">
          <tr>
            <th>User</th>
            <th>Email</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in agentsOnline">
            <td>
              {{ user.name }}
            </td>
            <td>
              {{ user.email }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "AgentsOnline",

  data() {
    return {
      agentsOnline: [],
      isLoading: false,
      lastSeenAtUpdater: null
    }
  },

  methods: {
    async authenticateEcho() {
      // Setup Echo
      // const token = await this.$auth.getTokenSilently();
      const token = await this.$auth.getTokenPopup();
      window.Echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + token.access_token
      window.Echo.options.auth = {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      };
    },

    getAgentsOnline() {
      let vm = this;
      vm.isLoading = true;
      axios.get(API_BASE + '/users/users-online').then(r => {
        vm.isLoading = false;
        vm.agentsOnline = r.data;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.agentsOnline = [];
      });
    },

    setCurrentUserOnline() {
      let vm = this;
      axios.post(API_BASE + '/users/current-user/set-online').then(r => {
        vm.getAgentsOnline();
      }).catch(e => {
        console.log(e);
      });
    },

    setCurrentUserOffline() {
      let vm = this;
      axios.post(API_BASE + '/users/current-user/set-offline').then(r => {
        vm.getAgentsOnline();
      }).catch(e => {
        console.log(e);
      });
    },

    setupPresenceSync() {
      let vm = this;
      // window.Echo.join('agents-online')
      //     .joining((user) => {
      //         // console.log(user);
      //         axios.post(API_BASE + '/users/' + user.id + '/set-online');
      //     }).leaving((user) => {
      //     // console.log(user);
      //     axios.post(API_BASE + '/users/' + user.id + '/set-offline');
      // }).listen('UserOnline', (e) => {
      //     vm.getAgentsOnline();
      // }).listen('UserOffline', (e) => {
      //     vm.getAgentsOnline();
      // });
      window.Echo.channel('agents-online').listen('UserOnline', (e) => {
        vm.getAgentsOnline();
      }).listen('UserOffline', (e) => {
        vm.getAgentsOnline();
      });
    },

    setLastSeenAt() {
      axios.post(API_BASE + '/users/current-user/update-last-seen-at').catch(e => {
        console.log(e);
        this.$notify.error({title: "Are you connected to the internet?", message: "Error notifying server that you're online."});
      });
    }
  },

  async mounted() {
    await this.authenticateEcho();
    // this.setCurrentUserOnline();
    this.getAgentsOnline();
    this.setupPresenceSync();

    this.setLastSeenAt();
    this.lastSeenAtUpdater = window.setInterval(this.setLastSeenAt, 30000);
  }
}
</script>

<style scoped>

</style>
